module.exports = window["core-js/modules/es.object.keys.js"];